import { useCallback, useState } from 'react';

import { hooks } from '@febos-io/common';

import { getCompanyList } from '../config';

export function useCompanyListCallback(limit) {
  const [elements, setElements] = useState([]);
  const [meta, setMeta] = useState({ total: 0, pages: 0 });

  const {
    callback,
    loading,
  } = hooks.useRequestCallback(
    useCallback(async (request, filter, page) => {
      const {
        companies = [],
        total,
        totalPages: pages
      } = await request.exec(getCompanyList(page, limit, filter));
      setElements(companies);
      setMeta({ total, pages });
    }, [limit])
  );

  return {
    loading,
    elements,
    meta,
    callback
  };
}

export default useCompanyListCallback;
